import { Permission } from '@cims-online/shared'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { simpleRestoreNotification } from 'hooks/notificationHandler'
import { useRestoreIssueDispositionTypeMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { useDispositionTypesContext } from '../../DispositionTypesContext'
import { IssueDispositionType } from '../../DispositionTypesContext/types'

export function useRestore(): RestoreRowActionOptions<IssueDispositionType> {
  const { refetch } = useDispositionTypesContext()
  const [restore] = useRestoreIssueDispositionTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreIssueDispositionType: {
        dispositionType: { name },
      },
    }) => simpleRestoreNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreIssueDispositionType,
    metadata: ({ deleted, deletedDate, deletedUser }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      refetch()
    },
    default: 'active',
  }
}
